import { Layer } from '@deck.gl/core';
import { IFlightItem } from '../flights/types';
import { iconPixelSize } from '../IconType';
import { DeckLayerCreator } from './deck-layer-creator';
import { DeckOverlayPlugin } from './deck-overlay-plugin';
import { AnimatedScatterplotLayer } from './layers/scatterplot/animated-scatterplot-layer';
import { HidableScatterplotLayer } from './layers/scatterplot/hidable-scatterplot-layer';

export class DeckMarkers extends DeckLayerCreator {
    constructor(plugin: DeckOverlayPlugin) {
        super(plugin);
    }

    createLayers(data: IFlightItem[]): Layer[] {
        if (!this.props?.flights.active.visible) {
            return [];
        }

        const markerProps: Partial<HidableScatterplotLayer<IFlightItem>['props']> = {
            data,
            pickable: false,
            wrapLongitude: true,
            radiusUnits: 'pixels',
            radiusScale: this.getIconScale(),
            getRadius: (d) => iconPixelSize(d.iconType) / 2,
            getPosition: (d) => this.getFlightPosition(d),
            getIsHidden: (d) => this.getIsHidden(d),
            getFillColor: [255, 0, 0],
            stroked: false,
            updateTriggers: {
                all: [this.flightsVersion],
                getIsHidden: this.getIsHiddenUpdateTrigger
            }
        };

        return [
            this.isCoastMode
                ? new AnimatedScatterplotLayer<IFlightItem>({
                      ...markerProps,
                      id: 'animated-markers',
                      getId: (d) => d.id,
                      positionTexture: this.plugin.positionTexture
                  })
                : new HidableScatterplotLayer<IFlightItem>({
                      ...markerProps,
                      id: 'markers'
                  })
        ];
    }
}
